import { render, staticRenderFns } from "./UpgradeKubernetesCluster.vue?vue&type=template&id=4c9d66a4&scoped=true&"
import script from "./UpgradeKubernetesCluster.vue?vue&type=script&lang=js&"
export * from "./UpgradeKubernetesCluster.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeKubernetesCluster.vue?vue&type=style&index=0&id=4c9d66a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d66a4",
  null
  
)

export default component.exports